import { httpsCallable } from "firebase/functions";
import { functionsApi } from "../firebase";

const adminSetUserPasswordCallable = httpsCallable(functionsApi, "adminSetUserPassword");

export async function adminSetUserPassword({ userId, newPassword, revokeSessions = true }) {
  const res = await adminSetUserPasswordCallable({
    userId: (userId || "").trim(),
    newPassword,
    revokeSessions: revokeSessions === true,
  });
  return res?.data || {};
}
